import React from 'react';
import { PillarPage } from '../components/PillarPage';
import { finanzasPage } from '../data/pages/finanzas';
export function Finanzas() {
  return <PillarPage content={finanzasPage} data-id="element-261" data-mp="236lmnvtxajr2" />;
}